import { render, staticRenderFns } from "./SynchronizationList.vue?vue&type=template&id=a8e5fa76&"
import script from "./SynchronizationList.vue?vue&type=script&lang=js&"
export * from "./SynchronizationList.vue?vue&type=script&lang=js&"
import style0 from "./SynchronizationList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports